import { render } from "./SearchIcon.vue?vue&type=template&id=66479128"
import script from "./SearchIcon.vue?vue&type=script&lang=js"
export * from "./SearchIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__